module.exports = __webpack_public_path__ + "img/threeRed.0d870d77.jpg";